import { render, staticRenderFns } from "./ProgressionSteps.vue?vue&type=template&id=708f20ac"
import script from "./ProgressionSteps.vue?vue&type=script&lang=js"
export * from "./ProgressionSteps.vue?vue&type=script&lang=js"
import style0 from "./ProgressionSteps.vue?vue&type=style&index=0&id=708f20ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports